import { render, staticRenderFns } from "./ModalTiktokShopList.vue?vue&type=template&id=07ff19b1"
import script from "./ModalTiktokShopList.vue?vue&type=script&lang=js"
export * from "./ModalTiktokShopList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports